import * as moment from 'moment';
import { Place } from '../interfaces/interfaces';
import { FilterCriteria } from '../interfaces/interfaces';

export function checkIsNextDay(startTime: string, endTime: string) {
  if (moment(endTime).format('YYYY-MM-DD') != moment(startTime).format('YYYY-MM-DD')) {
    return true;
  } else {
    return false;
  }
}

